function profileInitial(name?: string | null, email?: string | null): string {
  return (name || email || '?').trim().charAt(0).toUpperCase() || '?';
}

export default function ProfileAvatar({
  email,
  name,
  size = 'regular',
  src,
}: {
  email?: string | null | undefined;
  name?: string | null | undefined;
  size?: 'regular' | 'small' | 'large';
  src?: string | null | undefined;
}) {
  return (
    <span aria-hidden className={`app-profile-avatar app-profile-avatar--${size}`}>
      {src ? <img alt="" src={src} /> : profileInitial(name, email)}
    </span>
  );
}
